import { Injectable } from '@angular/core';

import { GlobalServiceProvider } from '../global-service/global-service';
import { Http, RequestOptions, Headers, Response } from '@angular/http';


import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class AuthProvider {  
  baseUri: string = this.globalServiceProvider.appConfig.bss_api;
  data: any = {};
  constructor(
    public http: Http,
    public httpClient: HttpClient,
    public globalServiceProvider: GlobalServiceProvider,    
  ) {
    console.log('Hello AuthProvider Provider');
  }  
  public loginToBTCustomerApi(email): Observable<any[]> {
    console.log('this.baseUri:', this.baseUri);
    console.log('email:', email);
    let headers = new Headers({ 'Content-Type': 'application/json'});
    let options = new RequestOptions({ headers: headers });
    return this.http
      .post(this.baseUri + "/authenticatebtcustomer", { "username": email }, options)
      .map((res) => this.extractData(res))
      .catch(this.handleErrorObservable);
  }


  async getUser(email: string) {
    return new Promise((resolve: any, reject: any) => {
      this.httpClient.get(`${this.baseUri}/usercustomer/${email}`).subscribe((result: any) => {
        // console.log('result: ', result)
        resolve(result);
      }, () => {
        resolve();
      });
    });
  }

  async addUser(data: any) {
    return new Promise((resolve: any, reject: any) => {
      this.httpClient.post(`${this.baseUri}/addUserbtcustomer`, data).subscribe((result: any) => {
        resolve(result);
      }, () => {
        resolve();
      });
    });
  }

  private extractData(res: Response) {
    let body = JSON.stringify(res);
    let bodyTemp = JSON.parse(body)._body;
    // console.log(bodyTemp._body);
    return bodyTemp || null;
  }
  private handleErrorObservable(error: Response | any) {
    console.error(error.message || error);
    return Observable.throw(error.message || error);
  }
  
  async updateUser(data: any) {
    return new Promise((resolve: any, reject: any) => {
      this.httpClient.post(`${this.baseUri}/updateUserbtcustomer`, data).subscribe((result: any) => {
        resolve(result);
      }, () => {
        resolve();
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/auth/auth.ts